export default "__VITE_ASSET__36b88e82__"